export default __webpack_public_path__ + "static/media/add-svgrepo-com.44287136.svg";